export default class SlaTipoAlertaEnum {
    static Azul = 1
    static Verde = 2
    static Laranja = 3
    static Vermelho = 4
}
